import Splide, { AutoplayComponent } from '@splidejs/splide'
import Alpine from 'alpinejs'

export const initHero = () => {
    Alpine.data('initHero', () => ({
        splider: null as Splide | null,
        autoplay: null as AutoplayComponent | null,
        isPlaying: true,
        init() {
            this.splider = new Splide(this.$el, {
                autoplay: true,
                arrows: true,
                pagination: true,
                perPage: 1,
                perMove: 1,
                focus: 0,
                type: 'fade',
                rewind: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                resetProgress: false,
                speed: 2000,
                interval: 8000,
                lazyLoad: 'nearby',
            }).mount()

            this.autoplay = this.splider?.Components.Autoplay
        },

        togglePlayPause() {
            if (this.isPlaying) {
                this.autoplay?.pause()
                this.isPlaying = false
            } else {
                this.autoplay?.play()
                this.isPlaying = true
            }
        },
    }))
}
